export const AllowedExentions = [
    'ics',
    'doc',
    'docx',
    'pdf',
    'rtf',
    'xls',
    'xlsx',
    'xlsv',
    'csv',
    'txt',
    'jpg',
    'jpeg',
    'png',
    'gif',
    'ppt',
    'pptx',
    'mp3',
    'wav'
]

export const ImageExtensions = [
    'jpg', 'jpeg', 'png', 'gif'
]

// Ranges are [start, end] Unicode code points to reject: C0 control chars + DEL, zero-width
// space/joiners + LRM/RLM, bidi embedding/override controls, other invisible format chars, and BOM.
const CONTROL_AND_FORMAT_RANGES: Array<[number, number]> = [
    [0x0000, 0x001F],
    [0x007F, 0x007F],
    [0x200B, 0x200F],
    [0x202A, 0x202E],
    [0x2060, 0x206F],
    [0xFEFF, 0xFEFF],
]

const ILLEGAL_FILE_SYSTEM_CHARS = ['\\', '/', ':', '*', '?', '"', '<', '>', '|']

export const hasInvalidFileNameCharacters = (fileName: string): boolean => {
    if (!fileName) {
        return false;
    }

    for (let i = 0; i < fileName.length; i++) {
        const code = fileName.charCodeAt(i);
        const isControlOrFormat = CONTROL_AND_FORMAT_RANGES.some(([start, end]) => code >= start && code <= end);
        if (isControlOrFormat || ILLEGAL_FILE_SYSTEM_CHARS.includes(fileName[i])) {
            return true;
        }
    }

    return false;
}
